import { FilmTile } from "@features/atoms/FilmTile"
import { Appear } from "@features/motion/Appear"
import { defineBlock, EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Generic Header",
  tags: ["#page"],
}

export default defineBlock("layout/generic-header", (props) => {
  return (
    <div className="generic-header content-sized block-spacing py-6 flex flex-col gap-10 items-center text-blue">
      <Appear className="w-full flex flex-col gap-4 items-center justify-center">
        <p className="type-label-s text-center text-blue">
          <EditableText store={`generic_header_label`} placeholder="Enter Optional Subheading" />
        </p>
        <h1 className="type-title-xl text-center text-blue">
          {env.admin ? (
            <EditableText store={usePostTitleEditor()} as="span" placeholder="Enter title" />
          ) : (
            <>{props.page?.title}</>
          )}
        </h1>
      </Appear>
    </div>
  )
})
